
import { AgTableClient } from "app/shared/AgTable";
import PageHeader from "app/shared/PageHeader";
import React from "react";
const Recovery = () => {
    return (
        <>
            <iframe
                       height="100%"
                       style={{ width: "100%" }}
                       scrolling="no"
                       title="Iframe"
                       id="dashboardFrame"
                       src={
                         //getFormattedURL(dashboardURLConfig[domain]?.[activeKey]) ||
                         "https://analytics.zoho.in/open-view/103074000045008484/761de8b79e4aebc1ba043b2158ee22b9"
                       }
                     ></iframe>
        </>
    )
};
export default Recovery;


